import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class ActivityFeedPost extends ApplicationRecord {
  static jsonapiType = "activity_feed_posts";

  @Attr() text: string;

  @Attr() textWithHyperlink: string;

  @Attr() emoji: string;

  @Attr() title: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) updatedAt: string;
}

export default ActivityFeedPost;
